import { FlexRow, FullContainer, MaterialIcon } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { useSetRecoilState } from 'recoil';
import { useStyles } from '../../hooks/useStyles';
import { updateFleetReportsState } from '../../storage/fleetReports';
import { StyledTooltip } from '../ui/StyledTooltip';
import OperationalDownloadList from './OperationalDownloadList';

function OperationalDownloadsTab() {
  const { css, theme, classes } = useStyles();
  const setUpdateReports = useSetRecoilState(updateFleetReportsState);

  return (
    <FullContainer
      verticalFlex
      classNames={`${css({
        padding: theme.sizing.scale500,
        boxSizing: 'border-box',
      })}`}
      gap={theme.sizing.scale500}
    >
      <FlexRow classNames={classes.centeredEnd}>
        <StyledTooltip
          content="Recargar tabla"
          showArrow={false}
        >
          <Button
            size="compact"
            shape="square"
            onClick={() => setUpdateReports((prev) => !prev)}
            kind="tertiary"
          >
            <MaterialIcon name="refresh" />
          </Button>
        </StyledTooltip>
      </FlexRow>
      <OperationalDownloadList />
    </FullContainer>
  );
}

export default OperationalDownloadsTab;
